module.exports = __webpack_public_path__ + "img/advantage1.2b455012.svg";